import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- stores
import SessionStore from 'stores/SessionStore';
import {withRouter} from 'react-router-dom';

import AbstractMenuComponent from '../AbstractMenuComponent';

/**
 * Display a sidebar
 *
 * User metisMenu jquery library to handle sub-menus.
 *
 * @parent Layout
 *
 * Handle the header view.
 * Responsive mode: Hidden. The header will display the same content.
 */
class Sidebar extends AbstractMenuComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,

  };

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  render(): Object {
    /**
     * TODO: Add 'active' class to the current route.
     */

    if (!SessionStore.isLoggedIn()) {
      return null;
    }

    return (
      <nav role="navigation">
        <ul className="nav nav-sidebar navbar-collapse">
          {this.renderDashboard()}
          {this.renderOrder()}
          {this.renderPayment()}
          {this.renderRestaurantSettings()}
        </ul>
      </nav>
    );
  }
}

export default withRouter(Sidebar);
